import { Tag, TagProps } from '@chakra-ui/react';

export default function TagOnlyNewsletter(props: TagProps) {
  return (
    <Tag 
      variant="outline"
      ml="20px"
      colorScheme="gray"
      size="sm" 
      flexShrink={0}
      {...props}
    >
      Somente newsletter
    </Tag>
  )
}
